import { Box, Stack } from "@mui/material";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import { useLocation } from "react-router-dom";

import { PRODUCT_STATUS } from "../../../models/Product";
import {
  rewardInventoryPortalPaths,
  rootPaths,
} from "../../../routes/routePaths";
import { camelToCapitalisedWords } from "../../../utils/string";
import RoundedSquareChip from "../../atoms/RoundedSquareChip";
import Text from "../../atoms/Text";
import UnstyledLink from "../../atoms/UnstyledLink";
import FormHeader from "../FormHeader";

type DetailPageHeaderProps = {
  status?: PRODUCT_STATUS;
  isProduct?: boolean;
};

const DetailPageHeader = ({
  status,
  isProduct = true,
}: DetailPageHeaderProps) => {
  const location = useLocation();
  const currentPage = location.pathname.includes(
    rewardInventoryPortalPaths.createProduct,
  )
    ? "Create Product"
    : "Product";

  return (
    <Box>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        padding={isProduct ? "8px 30px" : "15px 30px 16px"}
        borderBottom={1}
        borderColor="mono.grey.1"
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <UnstyledLink
            to={
              isProduct
                ? rootPaths.rewardInventoryPortal
                : rootPaths.customer360
            }
          >
            <Text variant="title_small" color="mono.grey.2">
              {isProduct ? "Home" : "Search"}
            </Text>
          </UnstyledLink>
          <ArrowRightIcon />
          <Text variant="title_small">
            {isProduct ? currentPage : "Customer Details 360"}
          </Text>
        </Stack>
        {status && (
          <Box>
            <RoundedSquareChip
              variant={status}
              label={camelToCapitalisedWords(status)}
            />
          </Box>
        )}
        {isProduct && <FormHeader />}
      </Stack>
    </Box>
  );
};

export default DetailPageHeader;
